import { GzDateRangePickerWebComponent } from './component/GzDateRangePickerWebComponent';
import { DatePickerCalendarWebComponent } from './datePicker/datepicker-calendar';
import { DatePickerCalendarCellWebComponent } from './datePicker/datepicker-calendar-cell';

import {
  WEB_COMPONENT_GZ_DATEPICKER_CALENDAR,
  WEB_COMPONENT_GZ_DATEPICKER_CALENDAR_CELL,
} from '../../webcomponents.constants';

export { DatePickerCalendarCellWebComponent, DatePickerCalendarWebComponent, GzDateRangePickerWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_DATEPICKER_CALENDAR_CELL, DatePickerCalendarCellWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_DATEPICKER_CALENDAR, DatePickerCalendarWebComponent);
